/**
 * قبلاً با probe به /users دسترسی پلتفرمی را حدس می‌زد.
 * با ACL جدید، نقش و مجوزها از پاسخ auth/profile می‌آیند — probe دیگر لازم نیست.
 *
 * @param {ReturnType<import('./mapUser').mapUserFromApi>} user
 */
export async function enrichUserPlatformAccess(user) {
  return user;
}
